import { Heading } from '@acb_devel/design-system';
import { Text } from '@acb_devel/design-system';
import { Skeleton } from '@acb_devel/design-system';

import styles from './ProfileCardItem.module.scss';

export function ProfileCardItem({
  title,
  value,
  loading,
}: {
  title: string;
  value: string | null | undefined;
  loading: boolean;
}) {
  return (
    <div className={styles.profileCardItem}>
      <Heading as="p" variant="subhead">
        {title}
      </Heading>
      {loading ? (
        <Text variant="body-2">
          <Skeleton>Loading...</Skeleton>
        </Text>
      ) : (
        <>
          {value ? (
            <Text variant="body-2">
              {value?.split('<br>').map((item, index) => (
                <span key={index}>
                  {item}
                  <br />
                </span>
              ))}
            </Text>
          ) : (
            <Text variant="body-2">NS/NC</Text>
          )}
        </>
      )}
    </div>
  );
}
